module.exports = __webpack_public_path__ + "img/backArrow2x.png?1e5d8d8f433cf9646470db623cd88e6d";